(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('GpfsBatchInvoice', GpfsBatchInvoice);

    GpfsBatchInvoice.$inject = ['$resource'];

    function GpfsBatchInvoice ($resource) {
        var resourceUrl =  'api/gpfs-batch-invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
